import { render } from "./CustomerRankingTitle.vue?vue&type=template&id=4735799e&ts=true"
import script from "./CustomerRankingTitle.vue?vue&type=script&lang=ts"
export * from "./CustomerRankingTitle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__